export const BANNERS_DATA  = [
  {
    id: 0,
    title: "Zero banner of Seed to Tree, Main home page carousel.",
    slug: "seed-to-tree-main-carousel-0",
    images: {
      fallback: {
        src: "assets/images/carousel/c0/c0-original.png",
        alt: "Zero banner of Seed to Tree homepage carousel showcasing Admissions in turkey.",
      },
      small: {
        src: "assets/images/carousel/c0/c0-original.png",
        alt: "Optimized small version of the zero banner.",
      },
      medium: {
        src: "assets/images/carousel/c0/c0-original.png",
        alt: "Optimized medium version of the zero banner.",
      },
      large: {
        src: "assets/images/carousel/c0/c0-original.png",
        alt: "Optimized large version of the zero banner.",
      },
      extra_large: {
        src: "assets/images/carousel/c0/c0-original.png",
        alt: "Optimized extra-large version of the zero banner.",
      },
    },
  },
  {
    id: 1,
    title: "First banner of Seed to Tree, Main home page carousel.",
    slug: "seed-to-tree-main-carousel-1",
    images: {
      fallback: {
        src: "assets/images/carousel/c1/c1-480.jpg",
        alt: "First banner of Seed to Tree homepage carousel showcasing learning and growth.",
      },
      small: {
        src: "assets/images/carousel/c1/c1-480.webp",
        alt: "Optimized small version of the first banner.",
      },
      medium: {
        src: "assets/images/carousel/c1/c1-786.webp",
        alt: "Optimized medium version of the first banner.",
      },
      large: {
        src: "assets/images/carousel/c1/c1-1200.webp",
        alt: "Optimized large version of the first banner.",
      },
      extra_large: {
        src: "assets/images/carousel/c1/c1-1600.webp",
        alt: "Optimized extra-large version of the first banner.",
      },
    },
  },
  {
    id: 2,
    title: "Second banner of Seed to Tree, Main home page carousel.",
    slug: "seed-to-tree-main-carousel-2",
    images: {
      fallback: {
        src: "assets/images/carousel/c2/c2-480.jpg",
        alt: "Second banner of Seed to Tree homepage carousel featuring education and community.",
      },
      small: {
        src: "assets/images/carousel/c2/c2-480.webp",
        alt: "Optimized small version of the second banner.",
      },
      medium: {
        src: "assets/images/carousel/c2/c2-786.webp",
        alt: "Optimized medium version of the second banner.",
      },
      large: {
        src: "assets/images/carousel/c2/c2-1200.webp",
        alt: "Optimized large version of the second banner.",
      },
      extra_large: {
        src: "assets/images/carousel/c2/c2-1600.webp",
        alt: "Optimized extra-large version of the second banner.",
      },
    },
  },
  {
    id: 3,
    title: "Third banner of Seed to Tree, Main home page carousel.",
    slug: "seed-to-tree-main-carousel-3",
    images: {
      fallback: {
        src: "assets/images/carousel/c3/c3-480.jpg",
        alt: "Third banner of Seed to Tree homepage carousel highlighting knowledge and growth.",
      },
      small: {
        src: "assets/images/carousel/c3/c3-480.webp",
        alt: "Optimized small version of the third banner.",
      },
      medium: {
        src: "assets/images/carousel/c3/c3-786.webp",
        alt: "Optimized medium version of the third banner.",
      },
      large: {
        src: "assets/images/carousel/c3/c3-1200.webp",
        alt: "Optimized large version of the third banner.",
      },
      extra_large: {
        src: "assets/images/carousel/c3/c3-1600.webp",
        alt: "Optimized extra-large version of the third banner.",
      },
    },
  },
  {
    id: 4,
    title: "Fourth banner of Seed to Tree, Main home page carousel.",
    slug: "seed-to-tree-main-carousel-4",
    images: {
      fallback: {
        src: "assets/images/carousel/c4/c4-480.jpg",
        alt: "Fourth banner of Seed to Tree homepage carousel displaying an inspiring message.",
      },
      small: {
        src: "assets/images/carousel/c4/c4-480.webp",
        alt: "Optimized small version of the fourth banner.",
      },
      medium: {
        src: "assets/images/carousel/c4/c4-786.webp",
        alt: "Optimized medium version of the fourth banner.",
      },
      large: {
        src: "assets/images/carousel/c4/c4-1200.webp",
        alt: "Optimized large version of the fourth banner.",
      },
      extra_large: {
        src: "assets/images/carousel/c4/c4-1600.webp",
        alt: "Optimized extra-large version of the fourth banner.",
      },
    },
  },
  {
    id: 5,
    title: "Fifth banner of Seed to Tree, Main home page carousel.",
    slug: "seed-to-tree-main-carousel-5",
    images: {
      fallback: {
        src: "assets/images/carousel/c5/c5-480.jpg",
        alt: "Fifth banner of Seed to Tree homepage carousel showcasing learning and success.",
      },
      small: {
        src: "assets/images/carousel/c5/c5-480.webp",
        alt: "Optimized small version of the fifth banner.",
      },
      medium: {
        src: "assets/images/carousel/c5/c5-786.webp",
        alt: "Optimized medium version of the fifth banner.",
      },
      large: {
        src: "assets/images/carousel/c5/c5-1200.webp",
        alt: "Optimized large version of the fifth banner.",
      },
      extra_large: {
        src: "assets/images/carousel/c5/c5-1600.webp",
        alt: "Optimized extra-large version of the fifth banner.",
      },
    },
  },
];
